import { Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import Api from "../../Auth/Api";

function ModalEditarAgendamento({ show, onHide, agendamento, onSuccess }) {
    const token = JSON.parse(localStorage.getItem("user_token"));
    const { register, handleSubmit, setValue } = useForm();
    const [salvando, setSalvando] = useState(false);
    const [showAlerta, setShowAlerta] = useState(false);
    const [mensagemAlerta, setMensagemAlerta] = useState('');

    useEffect(() => {
        if (agendamento && show) {
            setValue('data_treinamento', agendamento.data_treinamento);
            setValue('hora_treinamento', agendamento.hora_treinamento?.substring(0, 5));
            setValue('alimentacao', agendamento.alimentacao === true || agendamento.alimentacao === 1 || agendamento.alimentacao === '1');
        }
    }, [agendamento, show, setValue]);

    const onSubmit = async (data) => {
        // Apenas Administradores podem editar, então não precisa validar antecedência
        await enviarEdicao(data);
    };

    const enviarEdicao = async (data) => {
        try {
            setSalvando(true);
            
            await Api.post(`/api/agendamentos-treinamentos/${agendamento.id}/editar`, data, {
                headers: { Authorization: `Bearer ${token}` }
            });
            
            // Delay de 1 segundo
            await new Promise(resolve => setTimeout(resolve, 1000));
            
            setSalvando(false);
            onHide(); // Fecha após salvar com sucesso
            onSuccess();
        } catch (error) {
            setSalvando(false);
            setMensagemAlerta(error.response?.data?.message || 'Erro ao editar agendamento');
            setShowAlerta(true);
        }
    };

    if (!agendamento) return null;

    return (
        <>
        <Modal size='lg' show={show} onHide={onHide} backdrop="static">
                <Modal.Header closeButton>
                    <span className="fw-semibold fs-5 text-primary">Editar Agendamento</span>
                </Modal.Header>
                <Modal.Body className="bg-gray-100 p-4">
                    <form onSubmit={handleSubmit(onSubmit)}>
                        {/* Informações de Leitura */}
                        <div className="row mb-4 pb-3 border-bottom">
                            <div className="col-12 col-md-3 mb-3 mb-md-0">
                                <label className="form-label text-primary fw-medium small">ID do Agendamento</label>
                                <div className="form-control bg-light border-secondary" style={{ cursor: 'not-allowed' }}>
                                    <span className="badge bg-secondary">#{agendamento.id}</span>
                                </div>
                            </div>
                            <div className="col-12 col-md-9">
                                <label className="form-label text-primary fw-medium small">Treinamento</label>
                                <div className="form-control bg-light border-secondary" style={{ cursor: 'not-allowed' }}>
                                    {agendamento.nome_curso}
                                </div>
                            </div>
                        </div>

                        {/* Campos Editáveis */}
                        <div className="mb-3">
                            <label className="form-label text-primary fw-medium">Data</label>
                            <input
                                type="date"
                                className="form-control border-new-light"
                                {...register('data_treinamento', { required: true })}
                            />
                        </div>
                        <div className="mb-3">
                            <label className="form-label text-primary fw-medium">Horário</label>
                            <input
                                type="time"
                                className="form-control border-new-light"
                                {...register('hora_treinamento', { required: true })}
                            />
                        </div>
                        <div className="mb-3">
                            <div className="form-check form-switch">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="alimentacao"
                                    {...register('alimentacao')}
                                />
                                <label className="form-check-label" htmlFor="alimentacao">
                                    <i className="bi bi-utensils me-2 text-primary"></i>
                                    Alimentação
                                </label>
                            </div>
                        </div>
                    </form>
                </Modal.Body>
                <Modal.Footer className="justify-content-end">
                    <div className="d-flex justify-content-end">
                        <button type="button" className="btn me-2" onClick={onHide} disabled={salvando}>
                            Cancelar
                        </button>
                        <button type="button" className="btn btn-primary" onClick={handleSubmit(onSubmit)} disabled={salvando}>
                            {salvando ? (
                                <>
                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                    Salvando...
                                </>
                            ) : (
                                'Salvar'
                            )}
                        </button>
                    </div>
                </Modal.Footer>
            </Modal>

            {/* Modal de Alerta */}
            <Modal show={showAlerta} onHide={() => setShowAlerta(false)} centered>
                <Modal.Header closeButton className="border-0">
                    <Modal.Title className="text-danger">
                        <i className="bi bi-exclamation-triangle-fill me-2"></i>
                        Erro
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="alert alert-danger mb-0" role="alert">
                        {mensagemAlerta}
                    </div>
                </Modal.Body>
                <Modal.Footer className="border-0">
                    <button className="btn btn-primary" onClick={() => setShowAlerta(false)}>
                        Entendi
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default ModalEditarAgendamento;

